import {createSystem, defaultConfig} from '@chakra-ui/react';

const rawColors = {
	black: '#211b18',
	gray: {
		'50': '#fcfaf7',
		'100': '#f5f1eb',
		'200': '#e7ddd1',
		'300': '#d6c6b5',
		'400': '#b59f8a',
		'500': '#8c7868',
		'600': '#6e5d51',
		'700': '#55463d',
		'800': '#40352f',
		'900': '#2b241f',
	},
	stone: {
		'50': '#f8f5f0',
		'100': '#eee6db',
		'200': '#ddd0bf',
		'300': '#c3ab91',
		'400': '#a0866e',
		'500': '#7a6c62',
		'600': '#62564e',
		'700': '#4f4540',
		'800': '#3f3733',
		'900': '#2f2a27',
	},
	marble: {
		'50': '#fffdf9',
		'100': '#fbf7f2',
		'200': '#f5f0e9',
		'300': '#ede5da',
		'400': '#e1d6c6',
		'500': '#cdbda8',
		'600': '#b09d85',
		'700': '#8b7765',
		'800': '#66584b',
		'900': '#40372f',
	},
	sandstone: {
		'50': '#fffaf2',
		'100': '#f6eddd',
		'200': '#ead9bb',
		'300': '#dcc39a',
		'400': '#c8aa79',
		'500': '#b38d5a',
		'600': '#957247',
		'700': '#765937',
		'800': '#59432a',
		'900': '#3d2e1d',
	},
	clay: {
		'50': '#fff6f1',
		'100': '#f8e1d8',
		'200': '#ebc0ae',
		'300': '#d89b84',
		'400': '#c17a63',
		'500': '#b48a78',
		'600': '#9c6e5f',
		'700': '#7d574a',
		'800': '#5d4036',
		'900': '#3d2923',
	},
	olive: {
		'50': '#f8faef',
		'100': '#e8edd6',
		'200': '#d3dcae',
		'300': '#bbc585',
		'400': '#a2ac67',
		'500': '#8a8d5f',
		'600': '#72754d',
		'700': '#5a5d3d',
		'800': '#43462f',
		'900': '#2d2f20',
	},
	mist: {
		'50': '#f6fafb',
		'100': '#e5eef1',
		'200': '#cfdee4',
		'300': '#aec6cf',
		'400': '#89acb8',
		'500': '#6a909b',
		'600': '#557b86',
		'700': '#44626b',
		'800': '#344b52',
		'900': '#223136',
	},
	shadow: {
		'50': '#f5f0ec',
		'100': '#ddd3ca',
		'200': '#c4b6a7',
		'300': '#a18f80',
		'400': '#7b6a5f',
		'500': '#4f4a44',
		'600': '#443e39',
		'700': '#37322e',
		'800': '#2b2724',
		'900': '#1c1917',
	},
	blue: {
		'50': '#f5f9fa',
		'100': '#d9e6ea',
		'200': '#baced5',
		'300': '#98b3bd',
		'400': '#7898a6',
		'500': '#4d6a75',
		'600': '#445c66',
		'700': '#374a52',
		'800': '#2b3940',
		'900': '#1c2529',
	},
	teal: {
		'50': '#f8faef',
		'100': '#e8edd6',
		'200': '#d3dcae',
		'300': '#bbc585',
		'400': '#a2ac67',
		'500': '#8a8d5f',
		'600': '#72754d',
		'700': '#5a5d3d',
		'800': '#43462f',
		'900': '#2d2f20',
	},
	purple: {
		'50': '#f6fafb',
		'100': '#e4edf0',
		'200': '#cadce2',
		'300': '#aac3cb',
		'400': '#89aab6',
		'500': '#678b98',
		'600': '#547481',
		'700': '#435b67',
		'800': '#31434d',
		'900': '#212c33',
	},
	pink: {
		'50': '#fff7f3',
		'100': '#f7e3db',
		'200': '#e9c3b5',
		'300': '#d7a08f',
		'400': '#c27f6b',
		'500': '#b06c59',
		'600': '#95584b',
		'700': '#77453c',
		'800': '#593330',
		'900': '#3b211f',
	},
	orange: {
		'50': '#fff7ef',
		'100': '#fde6d0',
		'200': '#f6ca9d',
		'300': '#ebaa6a',
		'400': '#da8a3f',
		'500': '#bf6d22',
		'600': '#9f5719',
		'700': '#7f4515',
		'800': '#60320d',
		'900': '#412107',
	},
	yellow: {
		'50': '#fffcef',
		'100': '#f8f0c8',
		'200': '#eedf8e',
		'300': '#e2c64a',
		'400': '#d2ad1b',
		'500': '#b8910f',
		'600': '#946e0f',
		'700': '#6f510c',
		'800': '#4d3908',
		'900': '#2e2204',
	},
	green: {
		'50': '#f4faf2',
		'100': '#d9eed3',
		'200': '#b4d7a9',
		'300': '#8fbd82',
		'400': '#6ea460',
		'500': '#4d8341',
		'600': '#3f6d35',
		'700': '#315429',
		'800': '#243c1d',
		'900': '#162412',
	},
	red: {
		'50': '#fff4f2',
		'100': '#ffd8d2',
		'200': '#f7b1a6',
		'300': '#eb8574',
		'400': '#d95f4b',
		'500': '#b84437',
		'600': '#97352b',
		'700': '#752821',
		'800': '#541b18',
		'900': '#340d0d',
	},
	primary: {
		'50': '#f7f2ee',
		'100': '#e5ddd4',
		'200': '#cabdad',
		'300': '#ab9885',
		'400': '#867363',
		'500': '#4f4a44',
		'600': '#443e39',
		'700': '#37322e',
		'800': '#2b2724',
		'900': '#1e1b19',
	},
} as const;

const toTokenValue = (value: string) => ({value});

const toTokenScale = (values: Record<string, string>) =>
	Object.fromEntries(Object.entries(values).map(([key, value]) => [key, toTokenValue(value)]));

const colorTokens = Object.fromEntries(
	Object.entries(rawColors).map(([name, value]) => [
		name,
		typeof value === 'string' ? toTokenValue(value) : toTokenScale(value),
	]),
);

const defaultGlobalStyles = {
	body: {
		bg: 'canvas',
		color: 'text',
		fontFeatureSettings: '"ss01" on, "cv01" on',
	},
	'html, body, #root': {
		minHeight: '100%',
	},
	'body::before': {
		content: '""',
		position: 'fixed',
		inset: 0,
		pointerEvents: 'none',
		backgroundImage:
			'radial-gradient(circle at top left, rgba(217, 200, 169, 0.28), transparent 35%), radial-gradient(circle at 80% 20%, rgba(195, 211, 217, 0.24), transparent 26%), linear-gradient(180deg, rgba(255,255,255,0.58) 0%, rgba(255,255,255,0) 44%)',
		zIndex: -2,
	},
	'body::after': {
		content: '""',
		position: 'fixed',
		inset: 0,
		pointerEvents: 'none',
		opacity: 0.1,
		backgroundImage: 'radial-gradient(rgba(79, 74, 68, 0.28) 0.6px, transparent 0.6px)',
		backgroundSize: '16px 16px',
		zIndex: -1,
	},
	'*::selection': {
		bg: 'sandstone.300',
		color: 'shadow.900',
	},
};

const mergeGlobalStyles = (globalStyles: Record<string, any>) => ({
	...defaultGlobalStyles,
	...globalStyles,
	body: {
		...defaultGlobalStyles.body,
		...(globalStyles.body ?? {}),
	},
});

const makeTheme = (globalStyles: Record<string, any> = {}) =>
	createSystem(defaultConfig, {
		theme: {
			tokens: {
				fonts: {
					heading: {value: "'Playfair Display', ui-serif, Georgia, serif"},
					body: {value: "'Montserrat', ui-sans-serif, system-ui, sans-serif"},
				},
				radii: {
					card: {value: '1.5rem'},
					panel: {value: '1.75rem'},
				},
				colors: colorTokens,
			},
			semanticTokens: {
				colors: {
					bg: {value: '{colors.marble.100}'},
					'bg.subtle': {value: '{colors.marble.50}'},
					'bg.muted': {value: '{colors.sandstone.100}'},
					'bg.emphasized': {value: '{colors.sandstone.200}'},
					'bg.panel': {value: '{colors.white}'},
					fg: {value: '{colors.shadow.700}'},
					'fg.muted': {value: '{colors.stone.600}'},
					'fg.subtle': {value: '{colors.stone.500}'},
					border: {value: '{colors.sandstone.200}'},
					'border.muted': {value: '{colors.marble.400}'},
					'border.subtle': {value: '{colors.sandstone.100}'},
					canvas: {value: '{colors.marble.100}'},
					canvasSubtle: {value: '{colors.marble.50}'},
					panel: {value: '{colors.white}'},
					panelMuted: {value: '{colors.marble.50}'},
					panelEmphasis: {value: '{colors.sandstone.100}'},
					text: {value: '{colors.shadow.700}'},
					subtleText: {value: '{colors.stone.600}'},
					borderStrong: {value: '{colors.sandstone.200}'},
					nav: {value: 'rgba(255, 253, 249, 0.88)'},
					heroFrom: {value: '{colors.marble.100}'},
					heroTo: {value: '{colors.sandstone.100}'},
					accent: {value: '{colors.clay.500}'},
					focusRing: {value: '{colors.clay.300}'},
					primary: {
						border: {value: '{colors.shadow.200}'},
						contrast: {value: '{colors.white}'},
						emphasized: {value: '{colors.shadow.300}'},
						fg: {value: '{colors.shadow.700}'},
						focusRing: {value: '{colors.clay.300}'},
						muted: {value: '{colors.shadow.100}'},
						solid: {value: '{colors.shadow.500}'},
						subtle: {value: '{colors.shadow.200}'},
					},
				},
			},
			layerStyles: {
				shell: {
					value: {
						backdropFilter: 'blur(22px)',
						background:
							'linear-gradient(180deg, rgba(255, 253, 249, 0.94) 0%, rgba(255, 248, 241, 0.9) 100%)',
						border: '1px solid',
						borderColor: 'border',
						borderRadius: 'panel',
						boxShadow: '0 22px 50px rgba(79, 74, 68, 0.10)',
					},
				},
				surface: {
					value: {
						backdropFilter: 'blur(16px)',
						background: 'rgba(255, 255, 255, 0.9)',
						border: '1px solid',
						borderColor: 'border',
						borderRadius: 'card',
						boxShadow: '0 12px 30px rgba(79, 74, 68, 0.08)',
					},
				},
				surfaceMuted: {
					value: {
						background: 'rgba(251, 247, 242, 0.96)',
						border: '1px solid',
						borderColor: 'border.subtle',
						borderRadius: 'card',
					},
				},
			},
			textStyles: {
				label: {
					value: {
						fontSize: '0.78rem',
						fontWeight: '600',
						letterSpacing: '0.08em',
						textTransform: 'uppercase',
					},
				},
			},
		},
		globalCss: mergeGlobalStyles(globalStyles) as any,
	});

export default makeTheme;
